<div class="p-3">
    <!-- Panel derecho simplificado (sin Friend List) -->
    <div class="d-flex align-items-center justify-content-between mb-2">
        <h6 class="m-0">Panel</h6>
        <i class="me-2" data-feather="settings"></i>
    </div>
    <p class="text-muted m-0" style="font-size: 13px;">Contenido rápido del panel lateral.</p>
</div>